<template>
  <div class="default">
    <base-header v-if="route.name !== 'checkout'" />
    <RouterView v-slot="{ Component }">
      <Transition name="opacity" mode="out-in">
        <component :is="Component" />
      </Transition>
    </RouterView>
  </div>
</template>

<script setup>
import BaseHeader from "@/components/base/base-header.vue";
import {useRoute} from "vue-router";

const route = useRoute()
</script>

<style lang="scss" scoped>

</style>